import {
    configApi
} from '../axios/api';
import {
    verifyCode
} from '../config/Utility';
import {
    baseUrl
} from '../config/CONSTANTS';

/**
 * 微信授权
 */
export const wxAuthBase = url => {
    let href = '';

    if (location.hostname !== '0.0.0.0') {
        href = url ? url : location.pathname + location.search;
        console.log(url, location.pathname, location.search, 44);
    }
    if (location.href.indexOf('token') === -1) {
        console.log(baseUrl, href, 99);
        location.href = `${baseUrl}/user/auth/wxauth?url=${encodeURIComponent(href)}`;
    }
};

/**
 * 初始化微信分享config
 */
export function initConfig(callback) {
    const href1 = location.hostname === '0.0.0.0' ? baseUrl : location.href;
    var href = window.entryUrl || href1
    configApi({
        url: href
    }).then(res => {
        if (verifyCode(res)) {
            const {
                appid,
                timestamp,
                noncestr,
                signature
            } = res.data;
            console.log(appid, timestamp, noncestr, signature);
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: appid, // 必填，公众号的唯一标识
                timestamp, // 必填，生成签名的时间戳
                nonceStr: noncestr, // 必填，生成签名的随机串
                signature, // 必填，签名
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'getLocation', 'scanQRCode', 'openLocation'] // 必填，需要使用的JS接口列表
            });
            if (callback) {
                callback();
            }
        }
    });
}


export const onOpenMap = data => {
    const {
        latitude,
        longitude,
        name,
        address
    } = data;
    wx.openLocation({
        latitude: parseFloat(latitude), // 纬度，浮点数，范围为90 ~ -90
        longitude: parseFloat(longitude), // 经度，浮点数，范围为180 ~ -180。
        name: name, // 位置名
        address: address, // 地址详情说明
        scale: 16, // 地图缩放级别,整形值,范围从1~28。默认为最大
        infoUrl: 'http://look.wx.xxxxxx.cn/look' // 在查看位置界面底部显示的超链接,可点击跳转
    });
};


/**
 * 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口（即将废弃）
 */
export const onMenuShareTimeline = data => {
    const {
        title,
        link,
        imgUrl
    } = data;
    wx.onMenuShareTimeline({
        title, // 分享标题
        link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl, // 分享图标
        success: function () {
            // 用户点击了分享后执行的回调函数
        },
    });
};

/**
 * 获取“分享给朋友”按钮点击状态及自定义分享内容接口（即将废弃）
 */
export const onMenuShareAppMessage = data => {
    const {
        title,
        link,
        imgUrl,
        desc
    } = data;
    wx.onMenuShareAppMessage({
        title, // 分享标题
        desc, // 分享描述
        link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl, // 分享图标
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
            // 用户点击了分享后执行的回调函数
        }
    });
};

export const scanQRCode = () => {
    wx.scanQRCode({
        desc: 'scanQRCode desc',
        needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
            return res
        },
        error: function (res) {
            if (res.errMsg.indexOf('function_not_exist') > 0) {
                alert('版本过低请升级')
            }
        }
    });
};
/**
 * 微信公众号支付
 */
export const wxPay = data => {
    return new Promise(function (resolve) {
        WeixinJSBridge.invoke(
            'getBrandWCPayRequest', data,
            function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
                    resolve({
                        status: true
                    });
                } else {
                    resolve({
                        status: false
                    });
                }
            }
        );
    })
};


// WEBPACK FOOTER //
// ./src/utils/wxUtils.js